export default __webpack_public_path__ + "static/SteelIron-b929776f1a655d8bf49b475e309e36af.jpg";